import React, { useState, useRef, useEffect } from 'react';
import { Link } from 'react-router-dom';
import './Navbar.css';

const Navbar = () => {
  const [activeDropdown, setActiveDropdown] = useState(null);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const timeoutRef = useRef(null);

  const handleMouseEnter = (menu) => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
      timeoutRef.current = null;
    }
    setActiveDropdown(menu);
  };

  const handleMouseLeave = () => {
    timeoutRef.current = setTimeout(() => {
      setActiveDropdown(null);
    }, 200);
  };

  const handleClick = (menu) => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
      timeoutRef.current = null;
    }
    setActiveDropdown(activeDropdown === menu ? null : menu);
  };

  const toggleMobileMenu = () => {
    setMobileMenuOpen(!mobileMenuOpen);
    setActiveDropdown(null);
  };

  useEffect(() => {
    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    };
  }, []);

  return (
    <nav className="navbar">
      <div className="navbar-container">
      <Link to="/" className="navbar-logo">
  <img src="/images/abvig-logo.png" alt="ABVIG Logo" className="logo-image" />
</Link>

        <div className="menu-icon" onClick={toggleMobileMenu}>
          <span className={mobileMenuOpen ? 'hamburger active' : 'hamburger'}></span>
        </div>

        <ul className={mobileMenuOpen ? 'nav-menu active' : 'nav-menu'}>
          <li className="nav-item">
            <Link to="/" className="nav-link" onClick={() => setMobileMenuOpen(false)}>
              Home
            </Link>
          </li>

  {/* About Us */}
<li 
  className="nav-item dropdown"
  onMouseEnter={() => handleMouseEnter('about')}
  onMouseLeave={handleMouseLeave}
>
  <span 
    className="nav-link" 
    onClick={() => handleClick('about')}
  >
    About Us <span className="arrow">▾</span>
  </span>
  <ul className={activeDropdown === 'about' ? 'dropdown-menu active' : 'dropdown-menu'}>
    <li><Link to="/who-we-are" onClick={() => setMobileMenuOpen(false)}>Who We Are</Link></li>
    <li><Link to="/board-patrons" onClick={() => setMobileMenuOpen(false)}>Board of Patrons</Link></li>
    <li><Link to="/board-directors" onClick={() => setMobileMenuOpen(false)}>Board of Directors</Link></li>
    <li><Link to="/management-staff" onClick={() => setMobileMenuOpen(false)}>Management Staff</Link></li>
    <li><Link to="/interns-volunteers" onClick={() => setMobileMenuOpen(false)}>Interns & Volunteers</Link></li>
    <li><Link to="/career" onClick={() => setMobileMenuOpen(false)}>Career</Link></li>  {/* ← New */}
    <li><Link to="/contact-us" onClick={() => setMobileMenuOpen(false)}>Contact Us</Link></li>
  </ul>
</li>

 {/* Global Business Events */}
<li 
  className="nav-item dropdown"
  onMouseEnter={() => handleMouseEnter('events')}
  onMouseLeave={handleMouseLeave}
>
  <span 
    className="nav-link" 
    onClick={() => handleClick('events')}
  >
    Global Business Events <span className="arrow">▾</span>
  </span>
  <ul className={activeDropdown === 'events' ? 'dropdown-menu active' : 'dropdown-menu'}>
    <li className="dropdown-item">
      <Link to="/conferences" onClick={() => setMobileMenuOpen(false)}>
        Conferences
      </Link>
      <ul className="sub-dropdown">
        <li><Link to="/upcoming-conferences" onClick={() => setMobileMenuOpen(false)}>Upcoming Conferences</Link></li>
        <li><Link to="/previous-conferences" onClick={() => setMobileMenuOpen(false)}>Previous Conferences</Link></li>
      </ul>
    </li>
    <li className="dropdown-item">
      <Link to="/workshop" onClick={() => setMobileMenuOpen(false)}>
        Workshop
      </Link>
      <ul className="sub-dropdown">
        <li><Link to="/upcoming-workshop" onClick={() => setMobileMenuOpen(false)}>Upcoming Workshop</Link></li>
        <li><Link to="/past-workshop" onClick={() => setMobileMenuOpen(false)}>Past Workshop</Link></li>
      </ul>
    </li>
    <li className="dropdown-item">
      <Link to="/training" onClick={() => setMobileMenuOpen(false)}>
        Training
      </Link>
      <ul className="sub-dropdown">
        <li><Link to="/upcoming-training" onClick={() => setMobileMenuOpen(false)}>Upcoming Training</Link></li>
        <li><Link to="/past-training" onClick={() => setMobileMenuOpen(false)}>Past Training</Link></li>
      </ul>
    </li>
    <li className="dropdown-item">
      <Link to="/business-forum" onClick={() => setMobileMenuOpen(false)}>
        Business & Investment Forum
      </Link>
      <ul className="sub-dropdown">
        <li><Link to="/international-forum" onClick={() => setMobileMenuOpen(false)}>International Forum</Link></li>
        <li><Link to="/membership-benefits" onClick={() => setMobileMenuOpen(false)}>Membership Benefits</Link></li>
        <li><Link to="/members-showcase" onClick={() => setMobileMenuOpen(false)}>Members Showcase</Link></li>
        <li><Link to="/become-member" onClick={() => setMobileMenuOpen(false)}>Become a Forum Member</Link></li>
      </ul>
    </li>
    <li><Link to="/trade-mission" onClick={() => setMobileMenuOpen(false)}>Trade & Investment Mission</Link></li>
    <li><Link to="/partnership-collaboration" onClick={() => setMobileMenuOpen(false)}>Partnership & Collaboration</Link></li>
  </ul>
</li>

       {/* Our Services - Dropdown */}
<li 
  className="nav-item dropdown"
  onMouseEnter={() => handleMouseEnter('services')}
  onMouseLeave={handleMouseLeave}
>
  <span 
    className="nav-link" 
    onClick={() => handleClick('services')}
  >
    Our Services <span className="arrow">▾</span>
  </span>
  <ul className={activeDropdown === 'services' ? 'dropdown-menu active' : 'dropdown-menu'}>
    <li><Link to="/exports" onClick={() => setMobileMenuOpen(false)}>Exports & Turnkey Solutions</Link></li>
    <li><Link to="/vip-services" onClick={() => setMobileMenuOpen(false)}>VIP Services</Link></li>
    <li><Link to="/transportation-logistics" onClick={() => setMobileMenuOpen(false)}>Transportation & Logistics</Link></li>  {/* ← NEW */}
    <li><Link to="/business-incubator" onClick={() => setMobileMenuOpen(false)}>Business Incubator</Link></li>
  </ul>
</li>

          {/* Meet Us
          <li 
            className="nav-item dropdown"
            onMouseEnter={() => handleMouseEnter('meet')}
            onMouseLeave={handleMouseLeave}
          >
            <span 
              className="nav-link" 
              onClick={() => handleClick('meet')}
            >
              Meet Us <span className="arrow">▾</span>
            </span>
            <ul className={activeDropdown === 'meet' ? 'dropdown-menu active' : 'dropdown-menu'}>
              <li><Link to="/board-patrons" onClick={() => setMobileMenuOpen(false)}>Board of Patrons</Link></li>
              <li><Link to="/board-directors" onClick={() => setMobileMenuOpen(false)}>Board of Directors</Link></li>
              <li><Link to="/management-staff" onClick={() => setMobileMenuOpen(false)}>Management Staff</Link></li>
              <li><Link to="/interns-volunteers" onClick={() => setMobileMenuOpen(false)}>Interns & Volunteers</Link></li>
              <li><Link to="/contact-us" onClick={() => setMobileMenuOpen(false)}>Contact Us</Link></li>
            </ul>
          </li> */}

        {/* Activities */}
<li 
  className="nav-item dropdown"
  onMouseEnter={() => handleMouseEnter('activities')}
  onMouseLeave={handleMouseLeave}
>
  <span 
    className="nav-link" 
    onClick={() => handleClick('activities')}
  >
    Activities <span className="arrow">▾</span>
  </span>
  <ul className={activeDropdown === 'activities' ? 'dropdown-menu active' : 'dropdown-menu'}>
  <Link to="/blog" className="nav-link" onClick={() => setMobileMenuOpen(false)}>
    Blog
  </Link>
    <li><Link to="/projects" onClick={() => setMobileMenuOpen(false)}>Projects</Link></li>
    <li><Link to="/gallery" onClick={() => setMobileMenuOpen(false)}>Gallery</Link></li>
    <li><Link to="/corporate-activities" onClick={() => setMobileMenuOpen(false)}>Corporate Activities</Link></li>
    <li><Link to="/press-releases" onClick={() => setMobileMenuOpen(false)}>Press Releases</Link></li>
  </ul>
</li>
          {/* FAQ */}
          <li className="nav-item">
            <Link to="/faq" className="nav-link" onClick={() => setMobileMenuOpen(false)}>
              FAQ
            </Link>
          </li>
        </ul>
      </div>
    </nav>
  );
};

export default Navbar;